import { z } from "zod";

export const loginPasswordSchema = z.object({
  email: z.string().email("auth.login.error.invalidEmail"),
  password: z.string().min(8, "auth.register.error.passwordTooShort"),
});

export const loginOTPSchema = z.object({
  email: z.string().email("auth.login.error.invalidEmail"),
  otp: z.string().length(6, "auth.otp.error.invalid"),
});

export const registerSchema = z.object({
  first_name: z.string().min(1, "auth.register.error.firstNameRequired"),
  last_name: z.string().min(1, "auth.register.error.lastNameRequired"),
  email: z.string().email("auth.login.error.invalidEmail"),
  password: z
    .string()
    .min(8, "auth.register.error.passwordTooShort")
    .max(32, "auth.register.error.passwordTooLong"),
});

export const changePasswordSchema = z
  .object({
    new_password: z
      .string()
      .min(8, "auth.register.error.passwordTooShort")
      .max(32, "auth.register.error.passwordTooLong"),
    confirm_new_password: z.string().min(1, "common.required"),
  })
  .refine((data) => data.new_password === data.confirm_new_password, {
    message: "auth.changePassword.error.passwordMismatch",
    path: ["confirm_new_password"],
  });

/** Schema for the profile Change Password modal — includes the current password field. */
export const profileChangePasswordSchema = z
  .object({
    current_password: z.string().min(1, "common.required"),
    new_password: z
      .string()
      .min(8, "auth.register.error.passwordTooShort")
      .max(32, "auth.register.error.passwordTooLong"),
    confirm_new_password: z.string().min(1, "common.required"),
  })
  .refine((data) => data.new_password === data.confirm_new_password, {
    message: "auth.changePassword.error.passwordMismatch",
    path: ["confirm_new_password"],
  });

export type LoginPasswordValues = z.infer<typeof loginPasswordSchema>;
export type LoginOTPValues = z.infer<typeof loginOTPSchema>;
export type RegisterValues = z.infer<typeof registerSchema>;
export type ChangePasswordValues = z.infer<typeof changePasswordSchema>;
export type ProfileChangePasswordValues = z.infer<typeof profileChangePasswordSchema>;

export const forgotPasswordSchema = z.object({
  email: z.string().email("auth.login.error.invalidEmail"),
});

export const resetPasswordSchema = z
  .object({
    new_password: z
      .string()
      .min(8, "auth.register.error.passwordTooShort")
      .max(32, "auth.register.error.passwordTooLong"),
    confirm_new_password: z.string().min(1, "common.required"),
  })
  .refine((data) => data.new_password === data.confirm_new_password, {
    message: "auth.changePassword.error.passwordMismatch",
    path: ["confirm_new_password"],
  });

export type ForgotPasswordValues = z.infer<typeof forgotPasswordSchema>;
export type ResetPasswordValues = z.infer<typeof resetPasswordSchema>;
